if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        // this.addEventListener('change', debouncedOnChange.bind(this));
        this.addEventListener('change', (event) => {
          // ❌ Do nothing on quantity change
          event.stopPropagation();
        });
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput().addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput().addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.closest('.collection').dataset.id}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection').dataset.id}`
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const variantId = Object.keys(items)[0];
        const quantity = items[variantId];

        const body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ],
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(routes.cart_add_url, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((state) => {
            this.renderSections(state);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: state
            });
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.requestStarted = false;
          });
      }


      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
            section: this.closest('.collection-quick-add-bulk').dataset.id,
            selector: `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection-quick-add-bulk').dataset.id}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');

            const cartDrawer = document.querySelector('cart-drawer');
            setTimeout(() => {
              document
                .querySelector('#CartDrawer-Overlay')
                .addEventListener('click', cartDrawer.close.bind(cartDrawer));
            });

          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
if (!window.__quickAddBulkClickBound) {
  window.__quickAddBulkClickBound = true;
 
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.quick-add__submit_cart');
    if (!btn) return;
 
    e.preventDefault();
    e.stopPropagation();
 
    const bulk = btn.closest('quick-add-bulk');
    if (!bulk) return;
 
    const qtyInput = bulk.querySelector('.quantity__input');
    if (!qtyInput) return;
 
    const quantity = parseInt(qtyInput.value, 10);
    if (!quantity || quantity <= 0) return;
 
    await bulk.updateMultipleQty({
      [bulk.dataset.index]: quantity
    });

    

 
    const sectionsResponse = await fetch(
      `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
    );
    const sections = await sectionsResponse.json();
 
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = sections['cart-icon-bubble'];
    }
 
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
 
      const newInner = doc.querySelector('.drawer__inner');
      const currentInner = drawer.querySelector('.drawer__inner');
 
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }
 
      drawer.classList.remove('is-empty');
      drawer.open();
    }
 
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'quick-add-bulk',
    });
  });
}
